import React from 'react';
import { Button } from './ui/button';
import { MapPin, Clock, MessageSquare } from 'lucide-react';
import { locationInfo } from '../mock';

const Hero = () => {
  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Animated space background */}
      <div className="absolute inset-0 bg-black">
        <div className="stars"></div>
        <div className="stars2"></div>
        <div className="stars3"></div>
      </div>

      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/50 to-black"></div>

      {/* Content */}
      <div className="relative z-10 max-w-6xl mx-auto px-6 py-20 text-center">
        <div className="animate-float mb-8">
          <img 
            src="https://customer-assets.emergentagent.com/job_wiener-wagon/artifacts/8d152tg4_grok_image_xu381va-1.png" 
            alt="Sauce Dogz Astronaut Mascot" 
            className="w-72 h-72 mx-auto object-contain drop-shadow-2xl"
          />
        </div>
        
        <h1 className="text-7xl md:text-8xl font-bold mb-6 tracking-tight">
          <span className="text-white">SAUCE</span>
          <span className="text-orange-500"> DOGZ</span>
        </h1>
        
        <p className="text-2xl md:text-3xl text-cyan-400 mb-4 font-light tracking-wide">
          Surprise, We Have Hot Dogs
        </p>
        
        <p className="text-lg text-gray-300 mb-12 max-w-2xl mx-auto leading-relaxed">
          Launching gourmet hot dogs into orbit. Experience flavors that are truly out of this world.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-6">
          <Button 
            onClick={() => scrollToSection('menu')}
            size="lg"
            className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-6 text-lg font-semibold rounded-full transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-orange-500/50"
          >
            Explore Menu
          </Button>
          
          <Button 
            onClick={() => scrollToSection('location')}
            size="lg"
            variant="outline"
            className="border-cyan-400 text-cyan-400 hover:bg-cyan-400 hover:text-black px-8 py-6 text-lg font-semibold rounded-full transition-all duration-300 hover:scale-105"
          >
            <MapPin className="w-5 h-5 mr-2" />
            Find Us
          </Button>
        </div>

        {/* Hours Information */}
        <div className="mt-8 flex items-center justify-center gap-3 text-gray-300">
          <Clock className="w-6 h-6 text-orange-500" />
          <div className="text-lg">
            <span className="font-semibold text-white">Open: </span>
            <span className="text-cyan-400">Saturday - Sunday</span>
            <span className="mx-2">|</span>
            <span className="text-orange-500">10:30 AM - 3:00 PM</span>
          </div>
        </div>

        {/* Floating elements */}
        <div className="absolute top-20 left-10 w-3 h-3 bg-orange-500 rounded-full animate-pulse"></div>
        <div className="absolute top-40 right-20 w-2 h-2 bg-cyan-400 rounded-full animate-pulse" style={{animationDelay: '0.5s'}}></div>
        <div className="absolute bottom-32 left-20 w-4 h-4 bg-cyan-400 rounded-full animate-pulse" style={{animationDelay: '1s'}}></div>
      </div>
    </section>
  );
};

export default Hero;